<template>
	<div>
		<!-- 工具栏 -->
		<div style="display: flex; justify-content: space-between;">
			<!-- 搜索 -->
			<div>
				<el-input style="width: 300px; margin-right: 10px;" prefix-icon="el-icon-edit" v-model="custName"
					size="mini" placeholder="请输入客户名称" clearable>
				</el-input>
				<el-input style="width: 300px; margin-right: 10px;" prefix-icon="el-icon-edit" v-model="linkName"
					size="mini" placeholder="请输入客户联系人姓名" clearable>
				</el-input>
				<span style="margin-right: 10px;"></span>
				<el-button type="primary" icon="el-icon-search" @click="onSearch" style="margin-left: 10px;"
					size="mini">搜索
				</el-button>
			</div>
			<!-- 右边工具 -->
			<div>
				<!-- <el-button type="success" icon="el-icon-user" @click="addCust" size="mini">添加新客户</el-button> -->
			</div>
		</div>

		<!-- 表格 -->
		<div style="margin-top: 20px;">
			<el-table :data="queryData" stripe border    
			   :row-style="{ height: '58px' }"
     			 height="calc(100vh - 280px)"
 				:cell-style="{padding: '5px 0'}"
				size="mini" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%">
				<!-- 多选框 -->
				<!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
				<el-table-column prop="linkName" label="联系人姓名"   align="center" width="110">
				</el-table-column>
				<el-table-column prop="sexName" label="性别"   align="center" width="60">
				</el-table-column>
				<el-table-column prop="custName" label="归属客户"   align="center" width="320">
				</el-table-column>
				<el-table-column prop="department" label="部门" align="center" width="100">
				</el-table-column>
				<el-table-column prop="job" label="职务" align="center" width="120">
				</el-table-column>
				<el-table-column prop="phone" label="手机号" align="center" width="120">
				</el-table-column>
				<el-table-column prop="telephone" label="办公电话" align="center" width="120">
				</el-table-column>
				<el-table-column prop="officeAddress" label="办公地址" align="center" width="320">
				</el-table-column>
				<el-table-column prop="relDegreeName" label="关系程度" align="center" width="120">
				</el-table-column>
				<el-table-column prop="powerName" label="权能" align="center" width="120">
				</el-table-column>
				<el-table-column prop="hobby" label="爱好" align="center" width="120">
				</el-table-column>
				<el-table-column prop="remark" label="备注" align="center" width="120">
				</el-table-column>
				<el-table-column prop="createTime" label="创建日期" align="center" width="150" :formatter="dateTimeTwoLine" class-name="cell-two-line">
				</el-table-column>
				<el-table-column label="操作" align="center" fixed="right" width="200">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="showEditView(scope.row)">编辑</el-button>
						<el-button type="danger" @click="deleteRecord(scope.row)" size="mini">删除</el-button>
					</template>
				</el-table-column>

			</el-table>
			<!-- 分页 -->
			<div style="display: flex; justify-content: flex-end; margin-top: 5px;">
				<el-pagination background @current-change="currentChange" @size-change="sizeChange"
					:page-sizes="[10, 20, 50,100,1000]" layout="sizes, prev, pager, next, jumper, ->, total"
					:total="total"
					:current-page="page">
				</el-pagination>
			</div>

		</div>

		<!-- 弹出框  dialogVisible:是否弹出   新增客户     下拉框不能回显 值的类型不同  一个整型，一个字符型      -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="80%"       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
			<div>
				<el-form ref="inputCustLinkForm" :model="inputCustLinkObj" :rules="rules">
					<el-row>
						<el-col :span="24">
							<el-form-item label="所属客户名称" prop="custName">
								<el-input type='text' size="mini" prefix-icon="el-icon-edit" style="width: 800px;"  disabled="true"
									v-model="inputCustLinkObj.custName" placeholder="请输入客户名称"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					
					<el-row>
						
						<el-col :span="6">
							<el-form-item label="联系人姓名" prop="linkName">
								<el-input type='text' size="mini" prefix-icon="el-icon-edit"  style="width: 150px;"
									v-model="inputCustLinkObj.linkName" placeholder="请输入联系人姓名"></el-input>
							</el-form-item>
						</el-col>

						<el-col :span="6">
							<el-form-item label="性别" prop="sex">
								<el-select v-model="inputCustLinkObj.sex" placeholder="请选择性别" size="mini" style="width: 150px;"
									 >
									<el-option v-for="item in sexs" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						
						<el-col :span="6">
							<el-form-item label="部门" prop="department">
								<el-input type='text' size="mini" prefix-icon="el-icon-edit"  style="width: 150px;"
									v-model="inputCustLinkObj.department" placeholder="请输入部门"></el-input>
							</el-form-item>
						</el-col>
						
						<el-col :span="6">
							<el-form-item label="职务" prop="job">
								<el-input type='text' size="mini" prefix-icon="el-icon-edit"   style="width: 150px;"
									v-model="inputCustLinkObj.job" placeholder="请输入职务"></el-input>
							</el-form-item>
						</el-col>
						
					</el-row>
					
					<!--   &nbsp;   &ensp;  &emsp;  &thinsp；       -->   
					<el-row>
						<el-col :span="6">
							<el-form-item label= "关系程度" prop="relDegree" style="margin-left: 22px;">
								<el-select v-model="inputCustLinkObj.relDegree" placeholder="请选择关系程度" size="mini"
									style="width: 150px;">
									<el-option v-for="item in relDegrees" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						
						<el-col :span="6">
							<el-form-item label="权能" prop="power">
								<el-select v-model="inputCustLinkObj.power" placeholder="请选择权能" size="mini"
									style="width: 150px;">
									<el-option v-for="item in powers" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						
						<el-col :span="12">
							<el-form-item label="爱好" prop="hobby" style="margin-left: 10px;">
								<el-input type='text' size="mini" prefix-icon="el-icon-edit" style="width: 448px;"
									v-model="inputCustLinkObj.hobby" placeholder="请输入爱好"></el-input>
							</el-form-item>
						</el-col>
						
					</el-row>

					<el-row>
						<el-col :span="16">
							<el-form-item label="办公地址" prop="officeAddress" style="margin-left: 22px;">
								<el-input type='text' size="mini" prefix-icon="el-icon-edit" style="width: 600px;"
									v-model="inputCustLinkObj.officeAddress" placeholder="请输入办公地址"></el-input>
							</el-form-item>
						</el-col>


						<el-col :span="8">
							<el-form-item label="办公电话" prop="telephone" style="margin-left: 12px;">
								<el-input type='text' size="mini" prefix-icon="el-icon-edit" style="width: 150px;"
									v-model="inputCustLinkObj.telephone" placeholder="请输入办公电话"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="16">
							<el-form-item label="家庭地址" prop="homeAddress" style="margin-left: 22px;">
								<el-input type='text' size="mini" prefix-icon="el-icon-edit" style="width: 600px;"
									v-model="inputCustLinkObj.homeAddress" placeholder="请输入家庭地址"></el-input>
							</el-form-item>
						</el-col>

						<el-col :span="8">
							<el-form-item label="联系方式" prop="phone">
								<el-input type='text' size="mini" prefix-icon="el-icon-edit" style="width: 150px;"
									v-model="inputCustLinkObj.phone" placeholder="请输入联系方式"></el-input>
							</el-form-item>
						</el-col>


					</el-row>
					
					<el-row>
						<el-col :span="24">
							<el-form-item label="备注描述" prop="remark" style="margin-left: 22px;">
								<el-input type='textarea' size="mini" prefix-icon="el-icon-edit" style="width: 600px;"
									v-model="inputCustLinkObj.remark" placeholder="请输入备注信息"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="doChance">取 消</el-button>
				<el-button type="primary" @click="doUpdateRecord">确 定</el-button>
			</span>
		</el-dialog>
        </el-dialog>


	</div>
</template>

<script>
export default {
  name: "CustList_man_list",
  data() {
    return {
      queryData: [], // 存放查询结果
      custName: "", // 查询使用
      linkName: "", // 查询使用
      sexs: [], // 性别下拉框
      relDegrees: [], // 关系程度下拉框
      powers: [], // 权能下拉框
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      title: "修改客户联系人信息",
      dialogVisible: false,
      // 编辑客户联系人对象
      inputCustLinkObj: {
        id: null, // 客户联系人id
        linkName: "",
        sex: "",
        department: "",
        job: "",
        relDegree: null,
        power: null,
        hobby: "",
        officeAddress: "",
        telephone: "",
        homeAddress: "",
        phone: "",
        remark: "",
      },

      rules: {
        linkName: [
          {
            required: true,
            message: "请输入联系人姓名",
            trigger: "blur",
          },
        ],
        department: [
          {
            required: true,
            message: "请输入所属部门",
            trigger: "blur",
          },
        ],
        job: [
          {
            required: true,
            message: "请选择职务",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.initDim();
    this.initData();
  },
  methods: {
    // 搜索/筛选入口：先回到第 1 页再查（避免在第 N 页搜索时结果不足一页而显示空白）
    onSearch() {
      this.page = 1;
      this.initData();
    },

    initData() {
      this.loading = true;
      let url =
        "/cust/link_man_list/?page=" + this.page + "&limit=" + this.limit;

      if (this.custName) {
        url += "&custName=" + this.custName;
      }
      if (this.linkName) {
        url += "&linkName=" + this.linkName;
      }
      this.getRequest(url).then((resp) => {
        this.loading = false;
        if (resp) {
          this.queryData = resp.data;
          this.total = resp.count;
        }
      });
    },
    initDim() {
      // 性别
      if (!window.sessionStorage.getItem("sexs")) {
        this.postRequest("/dim/dim_table_char/sex").then((resp) => {
          if (resp) {
            this.sexs = resp.result;
            this.saveDictCache("sexs", resp.result);
          }
        });
      } else {
        this.sexs = this.dictCache("sexs");
      }
      //  权能
      if (!window.sessionStorage.getItem("powers")) {
        this.postRequest("/dim/dim_table_char/power").then((resp) => {
          if (resp) {
            this.powers = resp.result;
            this.saveDictCache("powers", resp.result);
          }
        });
      } else {
        this.powers = this.dictCache("powers");
      }
      //  关系程度
      if (!window.sessionStorage.getItem("relDegrees")) {
        this.postRequest("/dim/dim_table_char/rel_degree").then((resp) => {
          if (resp) {
            this.relDegrees = resp.result;
            this.saveDictCache("relDegrees", resp.result);
          }
        });
      } else {
        this.relDegrees = this.dictCache("relDegrees");
      }
    },
    doChance() {
      this.dialogVisible = false;
      // this.initData()
    },
    doUpdateRecord() {
      this.$refs["inputCustLinkForm"].validate((valid) => {
        // alert(valid)
        if (valid) {
          //验证通过
          this.postRequest2("/cust/update_linkman", this.inputCustLinkObj).then(
            (resp) => {
              if (resp) {
                this.initData();
                this.dialogVisible = false;
              }
            }
          );
        }
      });
    },
    showEditView(data) {
      this.dialogVisible = true;
      this.inputCustLinkObj = data;
      this.inputCustLinkObj.sex = data.sex + ""; // 解决下拉框无法回显的问题
      this.inputCustLinkObj.power = data.power + "";
      this.inputCustLinkObj.relDegree = data.relDegree + "";
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initData();
    },
    sizeChange(limit) {
      this.page = 1; // 改每页条数：回到第 1 页
      this.limit = limit;
      this.initData();
    },
    deleteRecord(data) {
      this.$confirm(
        "此操作将永久删除 " + data.linkName + "的该条联系人明细, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.postRequest2("/cust/delete_linkman?id=" + data.id).then(
            (resp) => {
              if (resp) {
                this.initData();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
</style>
